export const ADD_TRIGGER_FOLDER = 'ADD_TRIGGER_FOLDER';
export const ADD_TRIGGER_FOLDER_SUCCESS = 'ADD_TRIGGER_FOLDER_SUCCESS';
export const ADD_TRIGGER_FOLDER_FAILURE = 'ADD_TRIGGER_FOLDER_FAILURE';

export const GET_TRIGGER_FOLDER = 'GET_TRIGGER_FOLDER';
export const GET_TRIGGER_FOLDER_SUCCESS = 'GET_TRIGGER_FOLDER_SUCCESS';
export const GET_TRIGGER_FOLDER_FAILURE = 'GET_TRIGGER_FOLDER_FAILURE';

export const UPDATE_TRIGGER_FOLDER = 'UPDATE_TRIGGER_FOLDER';
export const UPDATE_TRIGGER_FOLDER_SUCCESS = 'UPDATE_TRIGGER_FOLDER_SUCCESS';
export const UPDATE_TRIGGER_FOLDER_FAILURE = 'UPDATE_TRIGGER_FOLDER_FAILURE';

export const DELETE_TRIGGER_FOLDER = 'DELETE_TRIGGER_FOLDER';
export const DELETE_TRIGGER_FOLDER_SUCCESS = 'DELETE_TRIGGER_FOLDER_SUCCESS';
export const DELETE_TRIGGER_FOLDER_FAILURE = 'DELETE_TRIGGER_FOLDER_FAILURE';

export const HANDLE_PERMISSION_DENIED_MODAL = 'HANDLE_PERMISSION_DENIED_MODAL';
export const HANDLE_SELECTED_FOLDER = 'HANDLE_SELECTED_FOLDER';
export const HANDLE_TRIGGER_PRIVACY_LEVEL = 'HANDLE_TRIGGER_PRIVACY_LEVEL';
export const HANDLE_TRIGGER_SEARCH = 'HANDLE_TRIGGER_SEARCH';
export const  HANDLE_USER_WISE_FILTER = 'HANDLE_USER_WISE_FILTER';

export const ADD_TRIGGER = 'ADD_TRIGGER';
export const ADD_TRIGGER_SUCCESS = 'ADD_TRIGGER_SUCCESS';
export const ADD_TRIGGER_FAILURE = 'ADD_TRIGGER_FAILURE';

export const GET_TRIGGER = 'GET_TRIGGER';
export const GET_TRIGGER_SUCCESS = 'GET_TRIGGER_SUCCESS';
export const GET_TRIGGER_FAILURE = 'GET_TRIGGER_FAILURE'; 
export const GET_TRIGGER_MORE_DATA = 'GET_TRIGGER_MORE_DATA';
export const RECALL_TRIGGER = "RECALL_TRIGGER";

export const UPDATE_TRIGGER = 'UPDATE_TRIGGER';
export const UPDATE_TRIGGER_SUCCESS = 'UPDATE_TRIGGER_SUCCESS';
export const UPDATE_TRIGGER_FAILURE = 'UPDATE_TRIGGER_FAILURE';

export const DELETE_INSURANCE_TRIGGER = 'DELETE_INSURANCE_TRIGGER';
export const DELETE_INSURANCE_TRIGGER_SUCCESS = 'DELETE_INSURANCE_TRIGGER_SUCCESS';
export const DELETE_INSURANCE_TRIGGER_FAILURE = 'DELETE_INSURANCE_TRIGGER_FAILURE';

export const UPDATE_TRIGGER_STATUS = 'UPDATE_TRIGGER_STATUS';
export const UPDATE_TRIGGER_STATUS_SUCCESS = 'UPDATE_TRIGGER_STATUS_SUCCESS';
export const UPDATE_TRIGGER_STATUS_FAILURE = 'UPDATE_TRIGGER_STATUS_FAILURE';

export const DUPLICATE_INSURANCE_TRIGGER = 'DUPLICATE_INSURANCE_TRIGGER';
export const DUPLICATE_INSURANCE_TRIGGER_SUCCESS = 'DUPLICATE_INSURANCE_TRIGGER_SUCCESS';
export const DUPLICATE_INSURANCE_TRIGGER_FAILURE = 'DUPLICATE_INSURANCE_TRIGGER_FAILURE';